module.exports = __webpack_public_path__ + "static/glauber-sampaio-le2Ohc3TRS0-unsplash-05cccfb93899c790305085c889028720.png";